import { render, staticRenderFns, recyclableRender, components } from "./free-live-course-item.vue?vue&type=template&id=23c270d0&scoped=true&"
var renderjs
import script from "./free-live-course-item.vue?vue&type=script&lang=js&"
export * from "./free-live-course-item.vue?vue&type=script&lang=js&"
import style0 from "./free-live-course-item.vue?vue&type=style&index=0&id=23c270d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c270d0",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "components/free-live-course-item/free-live-course-item.vue"
export default component.exports